(function () {
  angular.module("pcmCommon")
    .factory("LocationItem", ["stopService", "ArrivalTime", function (stopService, ArrivalTime) {
      var typeIcons = {
        "Country": "ico-frame-box",
        "State": "ico-frame-box",
        "County": "ico-frame-box",
        "City": "ico-dot-circle-o",
        "Zip": "ico-dot-circle-o",
        "SPLC": "ico-point-location",
        "Street": "ico-envelope",
        "RouteNumber": "ico-highway",
        "RouteAlpha": "ico-highway",
        "POI": "ico-map-marker",
        "FullPostCode": "ico-point-location",
        "POIType": "ico-map-marker",
        "CustomPlace": "ico-map-marker",
        "AthenaPlace": "ico-map-marker",
        "None": "ico-point-location",
      };

      // The mapping of ResultType to ResultTypeString should be obtained from /api/search/resultTypes instead
      // of hard-coding.
      const resultTypeMapping = {
        "0": "Country",
        "1": "State",
        "2": "County",
        "3": "City",
        "4": "Zip",
        "5": "SPLC",
        "6": "Street",
        "7": "RouteNumber",
        "8": "RouteAlpha",
        // pchen: returned for Athena Places too
        "9": "POI",
        "10": "POIStreet",
        "11": "FullPostCode",
        "12": "POIType",
        "13": "CrossStreet",
        "14": "LatLon",
        "15": "CustomPlace",
        "16": "CustomPlaceStreet",
        // pchen: only returned for latlon lookup when includeTrimblePlaceIds=true
        "17": "AthenaPlace",
        "18": "None"
      };
      function LocationItem(data, name) {
        var self = this;
        //todo: figure out if this is the right solution for this (using data.PlaceId || data.Id).  data anywhere service returns back an 'Id' property with the Id, i think some other place returns back a 'PlaceId' property. Custom places return CompanyId verify this
        self.Id = data.PlaceId || data.Id;
        self.Name = name;
        self.Address = data.Address;
        self.Coords = data.Coords;
        self.TypeIcon = typeIcons["None"];
        // SWPWEB-1298, SWPWEB-1302
        self.origLatlon = data.origLatlon ?  data.origLatlon : null;
        if (data.ResultTypeString) {
          self.TypeIcon = typeIcons[data.ResultTypeString];
        } else if (data.ResultType && data.ResultType in resultTypeMapping) {
          data.ResultTypeString = resultTypeMapping[data.ResultType];
          self.TypeIcon = typeIcons[data.ResultTypeString];
        } else {
          if (data.Address.City !== "") {
            self.TypeIcon = typeIcons["City"];
          }
          if (data.Address.Zip !== "") {
            self.TypeIcon = typeIcons["Zip"];
          }
          if (data.Address.StreetAddress !== "") {
            self.TypeIcon = typeIcons["Street"];
          }
          if (data.PlaceName !== "") {
            self.TypeIcon = typeIcons["POI"];
          }
        }
        if (data.location) {
          data = data.location;
        }
        self.Icon = "destination";
        self.IconText = "D";
        // self.LineClass = (data.Address.StreetAddress === "") ? "noAddress" : "";
        self.CityStateZip =(data.Address.City!==null && data.Address.City!== ""? data.Address.City + ", ":"") + data.Address.State + (data.Address.Zip != null ? " " + data.Address.Zip : "");

        self.CountyStr = (data.Address.County !== "" && data.Address.County !== null) ? data.Address.County + " County" : "";
        self.Country = (data.Address.Country !== "" && data.Address.Country != null) ? data.Address.Country : "";

        populatePlaceName(data, name);
        self.ALKObj = data;

        self.PlaceNameID = actualDisplayPlaceNameId(data);

        self.isVisible = false;

        self.showMe = function () {
          this.isVisible = true;
        };

        self.hideMe = function () {
          this.isVisible = false;
        };

        //The duration in string format. Can be in hh:mm, hh.hh or mm
        self.duration = data.duration;
        if (!self.duration) {
          self.duration = "";
        }

        self.earliestArrivalTime = new ArrivalTime({
          type: 0,
          arrivalTime: data.earliestArrivalTime,
          checkboxLabel: "Earliest Arrival",
          weekdayTimeLabel: "Earliest arrive at (local time)"
        });

        self.latestArrivalTime = new ArrivalTime({
          type: 1,
          arrivalTime: data.latestArrivalTime,
          checkboxLabel: "Latest Arrival",
          weekDayTimeLabel: "Latest arrive at (local time)"
        });

        self.getDurationInHours = function () {
          return stopService.getHoursFromString(this.duration);
        };

        self.getDurationInSeconds = function () {
          return stopService.getSecondsFromString(this.duration);
        };

        self.etaInTimeWindow = function () {
          if (!this.earliestArrivalTime.hasValue() && !this.latestArrivalTime.hasValue()) {
            return true;
          }
          var startWindow = this.earliestArrivalTime.getWsMomentTime();
          var endWindow = this.latestArrivalTime.getWsMomentTime();
          var ETA = moment(this.ETA, "M/D/YYYY hh:mm A");
          return ETA >= startWindow && ETA <= endWindow;
        };

        self.getArrivalDateRange = function () {
          if (!this.earliestArrivalTime.hasValue() && !this.latestArrivalTime.hasValue()) {
            return "-";
          }
          return this.earliestArrivalTime.getUIFormattedTime() + " - " + this.latestArrivalTime.getUIFormattedTime();
        };

        //Copy over certain fields from another locationitem. (includes duration, arrival times, etc)
        self.copySavedData = function (origLocationItem) {
          this.duration = origLocationItem.duration;
          this.earliestArrivalTime = origLocationItem.earliestArrivalTime;
          this.latestArrivalTime = origLocationItem.latestArrivalTime;
        };

        //Subtract the duration from the WS returned hours because it factors in duration and we don't want it to
        self.getHoursWithoutDuration = function () {
          if (!this.duration || this.Hours === "0:00") {
            return this.Hours;
          }
          var stopDurationSeconds = stopService.getSecondsFromString(this.duration);
          var wsHoursInSeconds = moment.duration(this.Hours).asSeconds();
          if (wsHoursInSeconds <= 0 || stopDurationSeconds <= 0) {
            return this.Hours;
          }
          var diff = wsHoursInSeconds - stopDurationSeconds;
          var hours = diff / 3600;
          var hourComponent = Math.floor(hours);  //Whole number hours component
          var minuteComponent = Math.round((hours - hourComponent) * 60); //Whole number minutes component
          var minuteString = String(minuteComponent);
          if (minuteString.length === 1) {
            minuteString = "0" + minuteString;
          }
          return String(hourComponent) + ":" + minuteString;
        };

      }

      function populatePlaceName(data, name) {
        const resultTypesWithNameRegex = /^(POI|CustomPlace|AthenaPlace)$/;
        const {ShortString, ResultTypeString} = data;
        data.PlaceName = (resultTypesWithNameRegex.test(ResultTypeString)) ?
          ShortString :
          name;
      }

      function actualDisplayPlaceNameId({PlaceName, CompanyId, PlaceId}) {
        const placeID = CompanyId || PlaceId;
        if (placeID) {
          return `${PlaceName} (${placeID})`;
        } else {
          return  PlaceName;
        }
      }

      return LocationItem;
    }]);
})();



// WEBPACK FOOTER //
// ./app/pcm-common/LocationItem.module.js